export default __webpack_public_path__ + "static/media/1876.7ff27fd7.png";